import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";
import { driveLinkSource } from "./links/linkSource";

const DrivePage = lazy(() => import("./pages/DrivePage/DrivePage"));
const OfficePage = lazy(() => import("./office/OfficePage"));

/**
 * Documents Drive. It browses on /drive itself (?organization=, ?folder=, ?file=) so the shell keeps its
 * header. Other modules link to items by URL only with the stable /drive/folders/:folderId and
 * /drive/files/:fileId, which redirect to the query form (a file opens in its folder with its preview).
 */
export const driveModule: FrontModule = {
  id: "drive",
  version: "0.1.0",
  permission: "drive.read",
  label: "Documents Drive",
  icon: "file",
  description: "Your organization's files, native documents and spreadsheets, with previews of emails and media.",
  routes: [
    { path: "/drive/office/:fileId", Component: OfficePage },
    { path: "/drive", Component: DrivePage },
    { path: "/drive/organizations/:organizationId", Component: DrivePage },
    { path: "/drive/folders/:folderId", Component: DrivePage },
    { path: "/drive/files/:fileId", Component: DrivePage },
  ],
  // Other modules link to files and folders through the shell (docs/adr/0021).
  linkSources: [driveLinkSource],
  menu: [
    {
      id: "drive.home",
      label: "Documents Drive",
      icon: "file",
      path: "/drive",
      permission: "drive.read",
      description: "Your organization's files and folders",
    },
  ],
};

export default driveModule;
